export const FileService = {
    getFileNameFromPath: (path, extension) => {
        const end = extension ? path.length - extension.length : path.length; 
        return path.substring(path.lastIndexOf('/') + 1, end);
    },
    getExtension: (path) => {
        return path.substring(path.lastIndexOf('.'), path.length);
    }
}